import { actorQueries } from "@-/dev.improve.haniverse.database.schemas.actor.query";
import { useActorTableChangeVersion } from "@-/dev.improve.haniverse.lib.database.change.actor";
import { createUseQueryOptions } from "@-/dev.improve.haniverse.lib.query-options";

const LEARNED_GRAPHEMES_CONFIG = {
  where: { fsrsCardId: { isNotNull: true } },
  with: {
    userGraphemeMeaningCard: true,
    userGraphemePronunciationCard: true,
  },
} as const;

export function useGetLearnedGraphemesQueryKey() {
  const userCardsQueryOptions = actorQueries(
    import.meta.location,
  ).userCard.findMany.useQueryOptions(LEARNED_GRAPHEMES_CONFIG);
  const withTableChangeVersion = useActorTableChangeVersion("userCard", LEARNED_GRAPHEMES_CONFIG);

  return () => withTableChangeVersion(["learnedGraphemes", { userCardsQueryOptions }] as const);
}

export const [useLearnedGraphemesQueryOptions, learnedGraphemesQueryFn] = createUseQueryOptions(
  useGetLearnedGraphemesQueryKey,
  async ({ client, queryKey: [_, { userCardsQueryOptions }] }) => {
    // Soft-delete filter is injected by the wrapped `actorDb` query proxy at the
    // top level and by the overlays' relation `where` for the nested `with`.
    const studyCards = await client.fetchQuery(userCardsQueryOptions);

    const learned = new Set<string>();
    for (const studyCard of studyCards) {
      const meaningGrapheme = studyCard.userGraphemeMeaningCard?.grapheme;
      if (meaningGrapheme !== undefined) {
        learned.add(meaningGrapheme);
      }
      const pronunciationGrapheme = studyCard.userGraphemePronunciationCard?.grapheme;
      if (pronunciationGrapheme !== undefined) {
        learned.add(pronunciationGrapheme);
      }
    }
    return learned;
  },
);
